import { ColumnType, DataColumn } from "../useTable/types"

export type DataColumnHelper<T> = (
  col: Omit<DataColumn<T>, "type">
) => DataColumn<T>

export function data<T>(col: Omit<DataColumn<T>, "type">): DataColumn<T> {
  return {
    type: ColumnType.Data,
    ...col,
  }
}
